import { useContext, useEffect } from "react";
import { useImmer } from "use-immer";
import { errorMessage } from "../../../utils";
import { getStampCardsListApi } from "../api";
import qs from "qs";
import { AppContext } from "../../../store";
import { useDebouncedCallback } from "use-debounce";

export const useStampCardsList = () => {
  const { appState } = useContext(AppContext);
  const { globalData } = appState;

  const [state, setState] = useImmer({
    isLoading: true,
    dataList: [],
    filters: {
      searchText: "",
      status: "",
    },
  });

  const getStampCardsList = async ({ searchText = "", status = "" } = {}) => {
    setState(draft => {
      draft.isLoading = true;
    });

    const params = {};
    if (searchText) params.search = searchText;
    if (status) params.status = status;

    try {
      const res = await getStampCardsListApi({
        params,
        paramsSerializer: params => qs.stringify(params),
      });

      if (res?.success) {
        setState(draft => {
          draft.dataList = res.data;
        });
      }
    } catch (err) {
      errorMessage(err?.response?.data?.message || "Something went wrong");
    } finally {
      setState(draft => {
        draft.isLoading = false;
      });
    }
  };

  // Debounced search
  const debouncedSearch = useDebouncedCallback((value) => {
    getStampCardsList({ ...state.filters, searchText: value });
  }, 1000);

  useEffect(() => {
    getStampCardsList(state.filters);
  }, []);

  const onChangeFilter = (e) => {
    const { name, value } = e.target;

    setState(draft => {
      draft.filters[name] = value;
    });

    if (name === "searchText") {
      debouncedSearch(value);
    } else {
      getStampCardsList({ ...state.filters, [name]: value });
    }
  };

  const onSeachClear = () => {
    setState(draft => {
      draft.filters.searchText = "";
    });
    getStampCardsList({ ...state.filters, searchText: "" });
  };

  const resetFilters = () => {
    setState(draft => {
      draft.filters.searchText = "";
      draft.filters.status = "";
    });
    getStampCardsList({ searchText: "", status: "" });
  };

  return {
    state,
    globalData,
    onChangeFilter,
    onSeachClear,
    resetFilters,
  };
};
